<h3 class="heading d-block" *ngIf="showHeading && totalItems > 0">
  Top {{ totalItems > 3 ? 3 : totalItems}} App<span *ngIf="totalItems > 0">s</span> from this Developer
</h3>
<div class="row" *ngIf="totalItems > 0">

  <div class="col" *ngIf="loadingApps">
    <i class="fa fa-spin fa-spinner"></i>
  </div>

  <ng-container *ngFor="let app of developerApps">
    <div class="{{colClass}} text-left">
      <a class="btn btn-link p-0" [attr.title]="app.appTitle"
        [routerLink]="['/insight/apps', app.appId, app.region, app.appStore, app.device]"
        [queryParams]="{country: 'GLOBAL', month: month}">
        <img [attr.src]="app.appIcon" alt="App Icon" onerror="this.src='/assets/icons/icon-72x72-grey.png';" />
        <div class="appTitle" *ngIf="!logoOnly">{{app.appTitle}}</div>
      </a>
    </div>
  </ng-container>

  <div class="col-12" *ngIf="!loadingApps && totalItems > limit && !hidePagination">
    <app-paginator (updatePageClick)="loadDeveloperApps($event)" [totalItems]="totalItems" [limit]="limit">
    </app-paginator>
  </div>
</div>
